<p-dialog
  modal="true"
  styleClass="atlas-dialog-l wl-transactions-grid-apply-payments-dialog"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h3>{{ 'revenue.transactions-grid.unapplied-payments.create.header' | translate | titlecase }}</h3>
  </ng-template>
  <form #form="ngForm">
    <div class="mct-flex mct-row mct-gap-80"  >
      <div class="mct-flex mct-col" >
        <div class="field-column">
          <div>
            <label>{{ 'invoices.invoice-builder.payment-tab.payment-type' | translate | titlecase }}</label>
            <p-select
              name="paymentType"
              optionLabel="PaymentType"
              dataKey="PaymentTypeId"
              placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}"
              [options]="paymentTypes"
              [style]="{ width: '100%' }"
              [(ngModel)]="selectedPaymentType"
              required
            ></p-select>
          </div>
          <div class="mct-flex mct-col" >
            <label>{{ 'invoices.invoice-builder.payment-tab.amount' | translate | titlecase }}</label>
            <input
              name="amount"
              #amountField="ngModel"
              [(ngModel)]="unappliedPayment.Amount"
              type="number"
              step="0.01"
              required
              wholeCents
              [attr.aria-invalid]="amountField.invalid && amountField.touched ? true : null"
              [attr.aria-describedby]="amountField.errors?.wholeCents && amountField.touched ? 'amount-whole-cents-error' : null"
            />
            <span
              id="amount-whole-cents-error"
              class="field-error-message"
              *ngIf="amountField.errors?.wholeCents && amountField.touched"
            >
              <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
              {{ 'revenue.transactions-grid.unapplied-payments.create.amount-whole-cents-error' | translate }}
            </span>
          </div>
          <div [hidden]="!creditCardPayment || !unappliedPayment.Amount" class="mt-50">
            <!-- <hr /> -->
            <wl-credit-card-input name="creditCard" [cardNotApplicable]="!creditCardPayment" [resolvedGateway]="resolvedGateway" [(ngModel)]="creditCardPayment"></wl-credit-card-input>
          </div>
          <div>
            <label>{{ 'invoices.invoice-builder.payment-tab.payment-source' | translate | titlecase }}</label>
            <p-select
              name="paymentSource"
              dataKey="PaymentSource"
              optionLabel="PaymentSource"
              placeholder="{{ 'invoices.invoice-builder.none-label' | translate }}"
              appendTo="body"
              [(ngModel)]="selectedPaymentSource"
              [style]="{ width: '100%' }"
              [options]="paymentSources"
            ></p-select>
          </div>
          <div class="mct-flex mct-row mct-gap-7"  >
            <div class="mct-flex mct-col" >
              <label>{{ 'invoices.invoice-builder.payment-tab.payment-date' | translate | titlecase }}</label>
              <wl-date-selector name="paymentDate" [(ngModel)]="unappliedPayment.PaymentDate"></wl-date-selector>
            </div>
            <div class="mct-flex mct-col" >
              <label>{{ 'invoices.invoice-builder.payment-tab.apply-date' | translate | titlecase }}</label>
              <wl-date-selector name="applyDate" [(ngModel)]="unappliedPayment.ApplyDate"></wl-date-selector>
            </div>
          </div>
        </div>
      </div>
      <div class="field-column">
        <div>
          <div class="mct-flex mct-col" >
            <label>{{ 'invoices.invoice-builder.payment-tab.batch-number' | translate | titlecase }}</label>
            <span>
              <strong>{{ unappliedPayment.Batch_Creation }}</strong>
            </span>
          </div>
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.check-number' | translate | titlecase }}</label>
          <input name="checkNum" type="text" [(ngModel)]="unappliedPayment.CheckNum" />
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.reference-number' | translate | titlecase }}</label>
          <input name="refNo" type="text" [(ngModel)]="unappliedPayment.Refno" />
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="this.show = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      [disabled]="
        isSaving ||
        form.controls.paymentType?.invalid ||
        form.controls.amount?.invalid ||
        ((creditCardPayment && unappliedPayment.Amount) && form.controls.creditCard?.invalid)
      "
      (click)="saveClicked()"
    >
      <span *ngIf="!isSaving">{{ 'common.save' | translate | uppercase }}</span>
      <wl-busy *ngIf="isSaving" [show]="isSaving"></wl-busy>
    </button>
  </ng-template>
</p-dialog>
